if (!global._babelPolyfill) {
    require("babel-polyfill");
}

import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import { constToCSS } from "../reducers/download";
import * as publicModalTypes from "../constants/modalTypes";

let connect = require("react-redux").connect;
var actions = require("../actions/actions");

const allModalClasses = {
    ICON_SHARE: "modern-modal no-bg-modal share",
    DOWNLOAD_FLOW: "modern-modal full-white no-bg-close"
};

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    handleDismiss(component, msg) {
        this.props.dismissModal(component, msg);
    }

    render() {
        let { result, modalTypes } = this.props;

        let modals = map(this.props.all, (modal, key) => {
            if (!modal || !modal.component) return null;

            let { component } = modal;

            let childProps = modal.props;

            let Component = modalTypes[component];

            if (!Component) {
                console.warn(`Modal component ${component} not found`);
                return null;
            }

            childProps.dismissModal = this.handleDismiss.bind(this, component);
            let dismiss = (
                <div
                    onClick={childProps.dismissModal}
                    title="close"
                    className="close"
                >
                    &times;
                </div>
            );

            let modalClasses = classnames(
                "modal-background",
                allModalClasses[component],
                `${constToCSS(component)}-modal-container`
            );

            return (
                <div className={modalClasses} key={key}>
                    <a
                        href="#"
                        className="modal-background-closer"
                        onClick={childProps.dismissModal.bind(
                            this,
                            actions.MODAL_BG_CLOSE
                        )}
                    />
                    <div className="modal-content">
                        {dismiss}
                        <Component {...childProps} result={result} />
                    </div>
                </div>
            );
        });
        return <div>{modals}</div>;
    }
}

function mapStateToProps(state, ownProps) {
    let all = state.modal.all;
    let result = state.modal.result;

    let modalTypes = {
        ...publicModalTypes,
        ...ownProps.modalTypes
    };

    return {
        all,
        result,
        modalTypes
    };
}

module.exports = connect(
    mapStateToProps,
    {
        dismissModal: actions.dismissModal
    }
)(Modal);
